"use strict";

angular.module("vendor")
.controller("SectionOrdersList", function(
    $scope, $stateParams, VendorOrderService, OrderStatusService, UserTypeService,
    StateExtensionService, UserService, FlashBag, gettextCatalog
) {
    $scope.isReady = false;

    if ($stateParams["order_cancelled"]) {
        FlashBag.success(gettextCatalog.getString(
            "The modification of order {{poNumber}} was successfully cancelled.",
            {poNumber: $stateParams["order_cancelled"]}
        ));
    }

    if ($stateParams["order_modified"]) {
        FlashBag.success(gettextCatalog.getString(
            "The order {{poNumber}} was successfully modified.",
            {poNumber: $stateParams["order_modified"]}
        ));
    }

    if (!$stateParams["creation_date_start"]) {
        UserService.isUserFetched().then(function onSuccess() {
            var defaultStartDate = (moment().utc().subtract(30, "days")).format();
            var dateFilter = {creation_date_start: moment(defaultStartDate).toISOString()};
            StateExtensionService.updateUrlParams(dateFilter);
            $scope.isReady = true;
        });
    }
    else {
        $scope.isReady = true;
    }

    $scope.service = VendorOrderService;
    $scope.statusNames = OrderStatusService.getStatusNamesTranslations();
    $scope.statusFilterService = OrderStatusService;
    $scope.contactTypeFilterService = UserTypeService;
    $scope.contactTypeNames = UserTypeService.getUserTypeNamesTranslations();
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/order/order-list.controller.js
// module id = 988
// module chunks = 0